import axios from 'axios'

import { handleRequestError } from './request'

export const RECEIVE_AUTONOMOUS_REGIONS = 'RECEIVE_AUTONOMOUS_REGIONS'
export const REQUEST_AUTONOMOUS_REGIONS = 'REQUEST_AUTONOMOUS_REGIONS'

/**
 * @deprecated use RTKQ hooks
 */
export const requestAutonomousRegions = () => (dispatch) => {
    dispatch({ type: REQUEST_AUTONOMOUS_REGIONS })

    axios
        .get('/autonomousRegions')
        .then((response) => {
            const items = response?.data || []
            dispatch(receiveAutonomousRegions({ items, fetchSuccessful: true }))
        })
        .catch((error) => {
            dispatch(receiveAutonomousRegions({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

/**
 * @deprecated use RTKQ hooks
 */
export const receiveAutonomousRegions = (data) => (dispatch) => {
    dispatch({ type: RECEIVE_AUTONOMOUS_REGIONS, data })
}
